import type { Brand, HubProduct, HubProductPage, Organization, Product, ProductPage } from "../types";
import { organizations } from "./organization";
import { hubs } from "./hub";

const createdAt = "2024-01-01T10:00:00Z";

const emptyProductPage: ProductPage = {
	nodes: [],
	totalCount: 0,
	totalPages: 0,
};

const emptyHubProductPage: HubProductPage = {
	nodes: [],
	totalCount: 0,
	totalPages: 0,
};

const defaultBrand = (organization: Organization): Brand => ({
	id: `NIKE-${organization.id}`,
	name: "Nike",
	logo: {
		id: `brand-logo-${organization.id}`,
		variant: "/storybook/shoe.webp",
	},
	organization,
	products: emptyProductPage,
	createdAt,
	updatedAt: createdAt,
});

const baseProduct = (i: number): Product => {
	const organization = i > 5 ? organizations.Rossmann : organizations.DM;
	return {
		id: `product-${i}`,
		name: "Super nice shoes blue",
		description:
			"The best scent you have smell in years, you will be so addicted that you won’t be able to stop burning the hell out of this wax.",
		defaultPrice: 1600,
		active: true,
		vat: 1900, // 19%
		organization,
		organizationId: organization.id,
		photo: {
			id: "img-1",
			variant: "/storybook/shoe.webp",
		},
		brand: defaultBrand(organization),
		brandId: `NIKE-${organization.id}`,
		hubProducts: emptyHubProductPage,
		imageId: "img-1",
		stripeProductId: `stripe-product-${i}`,
		createdAt,
		updatedAt: createdAt,
	};
};

const hubProducts: HubProduct[] = Array.from({ length: 10 }, (_, i) => {
	const product = baseProduct(i);
	const organization = product.organization;
	return {
		id: `hub-product-${i}`,
		hub: hubs.Default,
		organization,
		product,
		active: true,
		priceAmount: i % 2 === 0 ? product.defaultPrice : product.defaultPrice - 100,
		productInstances: {
			nodes: [],
			totalCount: 0,
			totalPages: 0,
		},
		stock: i > 5 ? 0 : 10,
		createdAt,
		updatedAt: createdAt,
	};
});

export const products = {
	page: {
		nodes: hubProducts,
		totalCount: hubProducts.length,
		totalPages: 1,
	} satisfies HubProductPage,
};
